import React from 'react';
import CountUp from 'react-countup';
import { motion } from 'framer-motion';

const ImpactItem = ({ metric, index }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1, ease: [0.25, 0.1, 0.25, 1.0] }}
            className="group relative flex flex-col items-center justify-center p-8 bg-surface/60 border border-border rounded-2xl hover:border-primary/30 hover:shadow-glow-sm transition-all duration-500"
        >
            {/* Hover Glow */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl" />

            {/* Metric Value */}
            <div className="relative flex items-baseline gap-1 mb-2">
                <span className="text-4xl md:text-5xl font-display font-bold text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-primary transition-all duration-300">
                    <CountUp
                        end={parseFloat(metric.value)}
                        duration={2.5}
                        separator=","
                        decimals={metric.value % 1 !== 0 ? 1 : 0}
                        enableScrollSpy
                        scrollSpyOnce
                    />
                </span>
                <span className="text-2xl font-mono text-primary font-bold">
                    {metric.suffix}
                </span>
            </div>

            {/* Label */}
            <span className="text-sm font-mono text-text-secondary uppercase tracking-wider mb-2">
                {metric.label}
            </span>

            {/* Context */}
            {metric.description && (
                <p className="text-xs text-text-tertiary text-center max-w-[200px] leading-relaxed">
                    {metric.description}
                </p>
            )}
        </motion.div>
    );
};

const ImpactNumbers = ({ metrics }) => {
    if (!metrics || !Array.isArray(metrics)) return null;

    return (
        <section className="py-20 bg-background border-b border-border">
            <div className="max-w-6xl mx-auto px-6">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                    {metrics.map((metric, index) => (
                        <ImpactItem
                            key={index}
                            metric={metric}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ImpactNumbers;
